import * as React from "react";

const Facebook: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <path
                d="M32 0v32H18.265V20.52h3.828l.729-4.749h-4.557V12.69c0-1.299.637-2.565 2.678-2.565h2.071V6.08s-1.88-.321-3.677-.321c-3.753 0-6.206 2.274-6.206 6.392v3.62H8.96v4.748h4.171V32H0V0h32z"
                fill="#2E5996"
                fillRule="nonzero"
            />
        </svg>
    );
};

export default React.memo(Facebook);
